import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

document.addEventListener('DOMContentLoaded', function (event) {
    window.addEventListener('load', function (e) {
        try {
            gsap.registerPlugin(ScrollTrigger);

            gsap.utils.toArray('.section-parallax').forEach((section, i) => {
                section.image = section.querySelectorAll('.parallax-image .image');

                section.image.forEach((image, i) => {
                    gsap.fromTo(image, {
                        y: () => {
                            if (window.matchMedia('(max-width: 767px)').matches) {
                                return 30 + (i * 5);
                            }

                            return 120 + (i * 80);
                        }
                    }, {
                        y: () => {
                            if (window.matchMedia('(max-width: 767px)').matches) {
                                return -30 - (i * 5);
                            }

                            return -120 - (i * 80);
                        },
                        ease: 'none',
                        scrollTrigger: {
                            trigger: section,
                            start: () => 'top bottom',
                            end: 'bottom top',
                            scrub: true
                        }
                    });
                });
            });
        } catch (error) {
            console.error('Erreur lors de l\'initialisation du parallax:', error);
        }
    }, false);
});
